import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    margin: ({ hasLabel }) => (hasLabel ? 0 : theme.spacing(1)),
    marginLeft: 0,
    marginRight: 0,
    '& .MuiOutlinedInput-root': {
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          border: '1px solid #dfdfdf',
        },
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #dfdfdf',
      width: '100%',
    },
    '& .MuiFormControl-root': {
      width: '100%',
      marginTop: 0,
      marginBottom: '0 !important',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      background: 'rgba(222, 222, 222, 0.32)',
      borderRadius: 8,
      cursor: 'not-allowed',
      '& .MuiInputBase-input.Mui-disabled': {
        background: 'transparent',
        cursor: 'not-allowed',
      },
      '& .MuiInputAdornment-root': {
        display: 'none',
      },
    },
    '& input': {
      marginLeft: 0,
      marginRight: 0,
      height: 18,
      position: 'relative',
      fontFamily: 'inherit',
      padding: '12px',
      transition: "all .1s ease-in",
      direction: 'rtl',
      '&::placeholder': {
        direction: 'ltr',
        textAlign: 'left',
      },
    },
  },
  label: {
    fontSize: '13px',
    color: '#455a64',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    lineHeight: 'initial',
    '&.MuiInputLabel-shrink': {
      transform: 'none !important',
    },
  },
  helperText: {
    minHeight: 13,
  },
  asterisk: {
    color: '#ef5350',
  },
}));
